import {
  Button,
  Grid,
  makeStyles,
  TextField,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Speech from "../../../util/speech";
import nickel_face from "../../../assets/images/nickel_face.png";
import penny_face from "../../../assets/images/penny_face.png";
import dime_face from "../../../assets/images/dime_face.png";
import quarter_face from "../../../assets/images/quarter_face.png";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

const useStyles = makeStyles((theme) => ({
  root: {},
  input: {
    fontSize: 40,
    textAlign: "center",
  },
}));

const Money = (props) => {
  const classes = useStyles({});
  const theme = useTheme();

  const mobileDevice = useMediaQuery(theme.breakpoints.down("sm"));
  const [currentQuestionId, setCurrentQuestionId] = useState(undefined);
  const [disableAnswer, setDisableAnswer] = useState(false);
  const [displayAnswer, setDisplayAnswer] = useState("");
  const [answer, setAnswer] = useState("");
  const [maxNumberLength, setMaxNumberLength] = useState(0);
  const [showSpinner, setShowSpinner] = useState(false);
  const [attemptCount, setAttemptCount] = useState(0);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [studentAnswer, setStudentAnswer] = useState("");
  const [showHands, setShowHands] = useState(false);
  const [question, setQuestion] = useState("");
  const pennySize = 19;
  const nickelSize = 21.21;
  const dimeSize = 17.9;
  const quarterSize = 24.3;
  const [open, setOpen] = useState(false);
  const [toastMessage, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  useEffect(() => {
    if (
      props.currentHomeWork &&
      props.currentHomeWork.questionId &&
      props.currentHomeWork.questionId !== currentQuestionId
    ) {
      setStudentAnswer(
        props.currentHomeWork.studentAnswer
          ? props.currentHomeWork.studentAnswer
          : ""
      );
      setCurrentQuestionId(props.currentHomeWork.questionId);
      setShowHands(true);
      setQuestion(props.currentHomeWork.firstVar);
      setAttemptCount(0);
      setAnswer(
        props.currentHomeWork.finalAnswer === "1"
          ? props.currentHomeWork.studentAnswer
          : ""
      );
      setDisableAnswer(
        props.currentHomeWork.finalAnswer === "1" ? true : false
      );
      setDisplayAnswer(
        props.currentHomeWork.finalAnswer === "1"
          ? props.currentHomeWork.answer
          : ""
      );

      setShowSpinner(false);
      if (props.currentHomeWork.voiceOver) {
        Speech(props.currentHomeWork.voiceOver);
      }
    }
  }, [props.currentHomeWork]);

  const isAnswerValid = () => {
    var isValid = false;
    console.log("VALIDATING ANSWER...", answer);
    if (answer){
       isAnswerCorrect();
      }
    else{
        setMessage("Invalid Answer!. Enter Value.")
        setMessageType("warning")
        handleClick() 
    }
  };

  const isAnswerCorrect = () => {
    var isCorrect = false;
    console.log("CHECKING ANSWER", answer);
    const answerString = answer;
    console.warn("answerString ", answerString);
    isCorrect =
      answerString &&
      answerString.length > 0 &&
      answerString === props.currentHomeWork.answer;
    if (isCorrect) {
      console.log("IS CORRECT, GO TO NEXT QUESTION");
      props.onSubmitQuestion(
        answerString,
        attemptCount + 1,
        true,
        props.currentHomeWork.questionId
      );
      setMessage("Correct Answer!. Good job.")
      setMessageType("success")
      handleClick()
    } else {
      console.log("WRONG ANSWER ");
      setAttemptCount(attemptCount + 1);

      if (attemptCount >= 2) {
        setMessage("Wrong Answer!. Try Next Question.")
        setMessageType("error")
        handleClick()
        props.onSubmitQuestion(
          answerString,
          attemptCount,
          false,
          props.currentHomeWork.questionId
        );
      } else {
        // props.onShowToast("Wrong Answer!. Try Again.", "warning");
        setMessage("Wrong Answer!. Try Again.")
        setMessageType("warning")
        handleClick()
      }
    }
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const handleClick = () => {
    setOpen(true);
  };

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const onSelection = (val) => {
    setAnswer(val);
  };

  const getCoinAnswer = (value) => {
    console.log("CAME HERE");
    switch (value) {
      case "1":
        return penny_face;
      case "5":
        return nickel_face;
      case "10":
        return dime_face;
      case "25":
        return quarter_face;
      default:
        return "";
    }
  };

  const onCoinSelection = (coin) => {
    console.log("CLICKED ", coin);
    setAnswer(coin);
  };

  const rendorMoneyCoins = () => {
    const { varList, qType, isRightAnswer } = props.currentHomeWork;
    if (qType === "slct") {
      return varList.map((item) => {
        if (item === 1) {
          return (
            <div key={`a-${answer}`}>
              <img
                onClick={() => onCoinSelection("1")}
                src={penny_face}
                border={2}
                style={{
                  width: 135,
                  height: 135,
                  marginRight: 10,
                  borderColor: disableAnswer
                    ? isRightAnswer
                      ? "green"
                      : "red"
                    : "primary",
                  borderWidth: answer === "1" ? 4 : 0,
                }}
              />
            </div>
          );
        } else if (item === 5) {
          return (
            <div key={`b-${answer}`}>
              <img
                onClick={() => onCoinSelection("5")}
                src={nickel_face}
                border={2}
                style={{
                  width: 140,
                  height: 140,
                  marginRight: 10,
                  borderColor: disableAnswer
                    ? isRightAnswer
                      ? "green"
                      : "red"
                    : "primary",
                  borderWidth: answer === "5" ? 4 : 0,
                }}
              />
            </div>
          );
        } else if (item === 10) {
          return (
            <div key={`c-${answer}`}>
              <img
                onClick={() => onCoinSelection("10")}
                src={dime_face}
                border={2}
                style={{
                  width: 120,
                  height: 120,
                  marginRight: 10,
                  borderColor: disableAnswer
                    ? isRightAnswer
                      ? "green"
                      : "red"
                    : "primary",
                  borderWidth: answer === "10" ? 4 : 0,
                }}
              />
            </div>
          );
        } else if (item === 25) {
          return (
            <div key={`d-${answer}`}>
              <img
                onClick={() => onCoinSelection("25")}
                src={quarter_face}
                border={2}
                style={{
                  width: 170,
                  height: 170,
                  marginRight: 10,
                  borderColor: disableAnswer
                    ? isRightAnswer
                      ? "green"
                      : "red"
                    : "primary",
                  borderWidth: answer === "25" ? 4 : 0,
                }}
              />
            </div>
          );
        }
      });
    } else {
      return varList.map((item) => {
        if (item === 1) {
          return (
            <div>
              <img
                src={penny_face}
                border={2}
                style={{
                  width: 135,
                  height: 135,
                  marginRight: 10,
                  borderColor: disableAnswer
                    ? isRightAnswer
                      ? "green"
                      : "red"
                    : "primary",
                  borderWidth: answer === "1" ? 4 : 0,
                }}
              />
            </div>
          );
        } else if (item === 5) {
          return (
            <div>
              <img
                src={nickel_face}
                border={2}
                style={{
                  width: 140,
                  height: 140,
                  marginRight: 10,
                  borderColor: disableAnswer
                    ? isRightAnswer
                      ? "green"
                      : "red"
                    : "primary",
                  borderWidth: answer === "5" ? 4 : 0,
                }}
              />
            </div>
          );
        } else if (item === 10) {
          return (
            <div>
              <img
                src={dime_face}
                border={2}
                style={{
                  width: 120,
                  height: 120,
                  marginRight: 10,
                  borderColor: disableAnswer
                    ? isRightAnswer
                      ? "green"
                      : "red"
                    : "primary",
                  borderWidth: answer === "10" ? 4 : 0,
                }}
              />
            </div>
          );
        } else if (item === 25) {
          return (
            <div>
              <img
                src={quarter_face}
                border={2}
                style={{
                  width: 170,
                  height: 170,
                  marginRight: 10,
                  borderColor: disableAnswer
                    ? isRightAnswer
                      ? "green"
                      : "red"
                    : "primary",
                  borderWidth: answer === "25" ? 4 : 0,
                }}
              />
            </div>
          );
        }
      });
    }
  };

  const clearAnswer = () => {
    setAnswer("");
    console.log("CLEAR ANSWER CALLED");
  };

  const addAnswerToState = (event) => {
    setAnswer(event.target.value);
  };

  const toggleHelpModal = (flag) => {
    setShowHelpModal(flag);
  };

  return (
    <Grid
      container
      style={{
        padding: 25,
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <Grid container style={{ padding: 16 }}>
        <Grid
          item
          xs={6}
          style={{
            display: "flex",
            justifyContent: "flex-start",
            flexDirection: mobileDevice ? "column" : "row",
          }}
        >
          <Button
            variant="outlined"
            color="primary"
            onClick={() => clearAnswer()}
            style={{ marginRight: 16 }}
          >
            CLEAR
          </Button>
          <Button variant="outlined" color="primary" onClick={isAnswerValid}>
            {disableAnswer ? "NEXT" : "SUBMIT"}
          </Button>
          <div
            style={{ marginLeft: 16, display: "flex", alignItems: "center" }}
          >
            {disableAnswer
              ? ""
              : attemptCount > 0
              ? "Attempts Remaining: " +
                (props.currentHomeWork.numOfAttemptsAllowed - attemptCount)
              : "Attempts Remaining: " +
                props.currentHomeWork.numOfAttemptsAllowed}
          </div>
        </Grid>
        <Grid
          item
          xs={6}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignSelf: "flex-start",
            flexDirection: mobileDevice ? "column" : "row",
          }}
        >
          {props.currentHomeWork && props.currentHomeWork.helpLink && <Button
            variant="outlined"
            color="primary"
            onClick={() => props.showHelp()}
            style={{ marginRight: 16 }}
          >
            HELP
          </Button>}
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              if (props.currentHomeWork && props.currentHomeWork.voiceOver) {
                Speech(props.currentHomeWork.voiceOver);
              }
            }}
          >
            READ OUT
          </Button>
          </Grid>
      </Grid>
      <Grid container style={{ flexDirection: "column" }}>
        <div style={{ fontSize: 30, margin: 10, alignSelf: "center" }}>
          {/* ---------------------------- QUESTION TEXT VIEW - ITEM  1 ---------------------------- */}
          {props.currentHomeWork.question}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {rendorMoneyCoins()}
        </div>
        {props.currentHomeWork.qType !== "slct" && (
          <div style={{ marginLeft: 20, alignSelf: "center" }}>
            {/* ---------------------------- ANSWER TEXT INPUT VIEW ---------------------------- */}
            <TextField
              variant="outlined"
              style={{
                fontSize: 30,
                width: 250,
                textAlign: "center",
                borderColor: "green",
                borderWidth: 2,
                color: "black",
              }}
              value={answer}
              InputProps={{
                classes: {
                  input: classes.input,
                },
              }}
              multiline={false}
              disabled={disableAnswer}
              onChange={addAnswerToState}
            ></TextField>
          </div>
        )}

        <div
          style={{
            flexDirection: "row",
            width: "100%",
            justifyContent: "center",
          }}
        >
          {/* ------------- ANSWER img RIGHT OR WRONG */}
          {/* <div style={{ flexDirection: "row", alignSelf: "center" }}>
                {disableAnswer && props.currentHomeWork.isRightAnswer && (
                  <Correctimg />
                )}
      
                {disableAnswer && !props.currentHomeWork.isRightAnswer && (
                  <Wrongimg />
                )}
              </div> */}
          {
            // ------------------   CORRECT ANSWER
            disableAnswer && !props.currentHomeWork.isRightAnswer && (
              <div
                style={{
                  alignSelf: "center",
                  marginTop: 20,
                  marginLeft: 50,
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <div style={{ fontSize: 24 }}>Correct Answer :{"   "}</div>
                <div style={{ fontSize: 48 }}>
                  <img
                    src={getCoinAnswer(displayAnswer)}
                    style={{
                      width: 100,
                      height: 100,
                      marginRight: 10,
                    }}
                  />
                </div>
              </div>
            )
          }
        </div>
      </Grid>
      <Grid><Snackbar
       open={open} autoHideDuration={3000} onClose={handleClose}>
        <Alert 
        key={`toastMessage-${toastMessage}`}
        onClose={handleClose} 
        severity={messageType}>
          {toastMessage}
        </Alert>
      </Snackbar>
      </Grid>
    </Grid>
  );
};

export default Money;
